import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-1.5 rounded-md transition-colors duration-150 bg-[var(--gp-surface-muted)] text-[var(--gp-ink-muted)] hover:bg-[var(--gp-brand-soft)] hover:text-[var(--gp-brand)]"
      aria-label="Toggle theme"
    >
      <FontAwesomeIcon
        icon={theme === 'light' ? faMoon : faSun}
        className="text-sm"
      />
    </button>
  );
};

export default ThemeToggle;
